import videojs from "video.js";

const ClickableComponent = videojs.getComponent('ClickableComponent');

class RadioButton extends ClickableComponent {
	constructor(player, options) {
		super(player, options);

		if (options.className) {
			this.addClass(options.className);
		}

		if (options.controlText) {
			this.controlText(options.controlText);
		}

		if (options.dataAttribute) {
			this.setAttribute(options.dataAttribute.name, options.dataAttribute.value);
		}
	}

	buildCSSClass() {
		return `vjs-radio-button ${super.buildCSSClass()}`;
	}

	select() {
		this.addClass('vjs-selected');
	}

	unselect() {
		this.removeClass('vjs-selected');
	}

	checkSelected() {
		return this.hasClass('vjs-selected');
	}
}


videojs.registerComponent('RadioButton', RadioButton);
